export function createKeyMap<T>(
	keyAccessor: (value: T) => string,
	elements: T[],
): { [keys: string]: T } {
	return elements.reduce((acc, value) => {
		acc[keyAccessor(value)] = value;
		return acc;
	}, {});
}
